<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#EBEBEB"
        fixed
        nav
        elevation="0"
        app
        :class="clipped ? 'clipped' : ''"
        style="border-radius: 0px; z-index: 9;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="d-flex align-center"
          :style="clipped ? 'padding-left: 6px;' : ''">
          <div v-if="clipped"
            class="mr-8">
            <v-img
              @click="clipped = false"
              contain
              width="40"
              height="40"
              alt="kominfoklaten"  
              :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
              class="ma-auto cursor-pointer">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <div v-if="user.role === 'admin' && ($route.path === '/program-p1' || $route.path === '/program' || $route.path === '/laporan/perkembangan' || $route.path === '/program-perubahan' || $route.path === '/laporan/kendala' || $route.path === '/laporan/capaian' || $route.path === '/laporan/perkembangan-opd-public')">
            <div v-if="user.role === 'admin'" style="width: 500px;">
              <v-autocomplete
                rounded

                :color="set_color"
                placeholder="Pilih Unit"

                hide-details
                height="43"

                :items="unit"
                item-text="title"
                item-value="id"
                :item-color="set_color"

                @click:clear="filter.unit_id = ''; changeQuery();"

                v-on:change="changeQuery()"
                v-model="filter.unit_id"
                style="background: #fff;">
              </v-autocomplete>
            </div>
          </div>
        </v-toolbar-title>

        <v-spacer/>

        <div
          class="mr-4">
          <v-avatar
            size="30">
            <v-img 
              width="100%"
              height="100%"
              alt="kominfoklaten"  
              :src="require('@/assets/icon/bell.png')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </div>

        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              dense
              color="transparent"
              style="max-width: 200px;">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 50px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="30"
                  class="mr-3">
                  <v-img 
                    width="100%"
                    height="100%"
                    alt="kominfoklaten"  
                    :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 font-weight-bold">
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="clipped"
        v-if="!date_password"
        width="275"
        color="#FFFFFF"
        dark
        fixed
        app>
        <div
          class="d-flex align-center cursor-pointer pa-3 py-1 mb-4"
          style="height: 64px; background: #EBEBEB;">
          <div
            class="d-flex align-center">
            <div v-if="!clipped"
              class="d-flex align-center">
              <v-img
                contain
                width="160"
                height="40"
                alt="kominfoklaten"  
                :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon_full.png')"
                class="ma-auto ml-1">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                large
                color="black">
                mdi-pan-left
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-list
          style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden;">
          <div 
            v-for="(item, index) in menu.left"
            :key="index">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link"
              color="transparent"
              :style="clipped ? 'padding: 0px 13px;' : ''">
              <v-list-item-avatar
                size="40"
                tile
                class="mr-4"
                :class="item.link.split('/')[1] === $route.path.split('/')[1] ? '' : 'box_false'"
                :color="item.link.split('/')[1] === $route.path.split('/')[1] ? set_color_rgb_down : '#FFFFFF'"
                :style="item.link.split('/')[1] === $route.path.split('/')[1] ? `border: 2px solid ${set_color};` : ''"
                style="border-radius: 10px !important;">
                <v-img 
                  contain
                  width="22"
                  height="22"
                  alt="kominfoklaten"  
                  :src="item.icon"
                  class="ma-auto">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        size="20"
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  :class="item.link.split('/')[1] === $route.path.split('/')[1] ? '' : 'grey--text'"
                  :style="item.link.split('/')[1] === $route.path.split('/')[1] ? `color: ${set_color}; font-weight: 600;` : ''">
                  {{ item.title }} 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-if="item.title !== 'Konfigurasi' && item.sub_menu.length > 0"
              v-model="item.active"
              :color="set_color"
              :append-icon="item.sub_menu.length > 0 ? 'mdi-pan-down' : ''"
              no-action
              :class="clipped ? 'clipped_header' : ''">
              <template v-slot:activator>
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item.active ? '' : 'box_false'"
                  :color="item.active ? set_color_rgb_down : '#FFFFFF'"
                  :style="item.active ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="kominfoklaten"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item.active ? 'font-weight-bold' : 'grey--text'"
                    :style="item.active === $route.fullPath ? `color: ${set_color};` : ''">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent">
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 sub-menu-title"
                    :class="item_sub.link === $route.path ? 'font-weight-bold' : 'grey--text'"
                    :style="item_sub.link === $route.path ? `color: ${set_color};` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <div
              v-if="item.title === 'Konfigurasi' && item.sub_menu.length > 0">
              <div
                class="body-1 black--text text-uppercase pa-4"
                style="font-weight: 600;">
                <span v-if="clipped">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="kominfoklaten"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </span>
                
                <span v-else>
                  {{ item.title }}
                </span>
              </div>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent"
                :style="clipped ? 'padding: 0px 13px;' : ''">
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? '' : 'box_false'"
                  :color="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? set_color_rgb_down : '#FFFFFF'"
                  :style="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="kominfoklaten"  
                    :src="item_sub.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>
                
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? '' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color}; font-weight: 600;` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        unit: [],
        filter: {unit_id: '501'},
        date_password: false,
        menu: {
          right: [
            {
              title: 'Profile',
              type: 'profile',
              link: '/profile?menu=profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        const fourMonthsAgo = new Date(this.$store.state.user.last_update_password_date);
        fourMonthsAgo.setMonth(fourMonthsAgo.getMonth() + 3);

        console.log(fourMonthsAgo)
        if(fourMonthsAgo < new Date()) {
          // this.dialog.password = true
          this.date_password = true
        } else {
          this.date_password = false
        }
        return this.$store.state.user
      },
      dpa () {
        return this.$store.state.dpa
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      counter () {
        return this.$store.state.counter
      },

      tahun_anggaran () {
        return this.$store.state.year
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    watch: {
      '$route.query.unit': function(val) {
        this.filter.unit = val
      },
    },
    created () {
      
    },
    mounted () {
      console.log(this.$store.state.user)
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      if (this.$store.state.user.role === 'admin') {
        this.$store.commit("setUnitId", '501')
      } else {
        this.$store.commit("setUnitId", this.$store.state.user.unit_id)
      }
      let menuAdmin = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                      {
                        title: 'Rekap OPD',
                        link: '/laporan/rekapitulasi',
                        active: false
                      },
                      {
                        title: 'Perkembangan Fisik & Keuangan Publik',
                        link: '/laporan/perkembangan-opd-public',
                        active: false
                      },
                      {
                        title: 'Rekap OPD Publik',
                        link: '/laporan/rekap-opd-public',
                        active: false
                      },
                      {
                        title: 'Data Summary Anggaran',
                        link: '/laporan/summary-anggaran',
                        active: false
                      },
                      {
                        title: 'Jumlah Program Kegiatan Sub Kegiatan OPD',
                        link: '/laporan/jumlah-program-kegiatan-sub',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Perbandingan SP2D',
                    icon: require('@/assets/icon/comparison.png'),
                    link: '/perbandingan-sp2d',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'User',
                    icon: require('@/assets/icon/user.png'),
                    link: '/user',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perangkat Daerah',
                        icon: require('@/assets/icon/company.png'),
                        link: '/master/perusahaan',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Import Anggaran',
                        icon: require('@/assets/icon/import.png'),
                        link: '/master/import-anggaran',
                        active: false,
                        sub_menu: []
                      }
                    ]
                  }
                ]
      this.menu.left = this.$store.state.user.role === 'admin' ? menuAdmin : this.$store.state.menu

      this.fetch()
      this.fetchUnit()
      // this.fetchDpa()
    },
    methods: {
      async fetch () {
        await get('admin/config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#DD5826')

              this.$store.commit("setColor", '#DD5826')
            }

            this.styles()

            this.fetchCounter()
          }
        })
      },

      async fetchDpa () {
        let params = {
          tahun: new Date().getFullYear()
        }
        await get('admin/dpa/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {

            TokenService.saveDpa(JSON.stringify(res.results.data[0]))

            this.$store.commit("setDpa", res.results.data[0])
            
          }
        })
      },

      changeQuery () {

        TokenService.saveUnitId(this.filter.unit_id)
        this.$store.commit("setUnitId", this.filter.unit_id)
        // if (this.filter.unit_id === '' || this.filter.unit_id === null || this.filter.unit_id === undefined) {
        //   this.$router.replace({'path': `${this.$route.path}`, 'query': {}})
        // } else {
        //   this.$router.replace({'path': `${this.$route.path}`, 'query': {'unit': this.filter.unit_id}})
        // }
      },

      async fetchCounter () {
        let counter = {
          total_company_quota: 0,
          total_company_quota_used: 0,
          total_company_quota_sisa: 0
        }

        TokenService.saveCounter(JSON.stringify(counter))

        this.$store.commit("setCounter", counter)
      },

      async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/login'
        } else {
          this.$router.push(item.link)
        }
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      },

      async fetchUnit () {

        let params = {
          limit: 100000,
          year: new Date().getFullYear()
        }
        
        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
            if(this.$route.query.unit !== undefined){
              this.filter.unit_id = this.$route.query.unit

            }
          }
        })
      },

      set_year (value) {
        this.$store.commit('setYear', value)
        
        TokenService.saveYear(value)
      }
    }
  }
</script>

<style>
  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .sub-menu-title {
    white-space: normal !important;
    line-height: 1.5 !important;
  }

  .clipped .v-toolbar__content {
    padding-left: 8px;
  }

  .v-navigation-drawer--mini-variant {
    width: 68px !important;
  }

  .clipped_header .v-list-group__header {
    padding: 0px 13px;
  }
</style>